import {
  optionsForPostRequest,
  fetchFromApi,
  optionsForFileRequest,
  optionsForPatchRequest,
} from './apiUtils';

const basePath = '/v1/submission';

const getSubmission = submissionId =>
  fetchFromApi(`${basePath}/${submissionId}`);

const getSubmissions = data =>
  fetchFromApi(`${basePath}/search`, optionsForPostRequest(data));

const getSubmissionsCalendar = data =>
  fetchFromApi(`${basePath}/calendar`, optionsForPostRequest(data));

const uploadSubmissionFile = (submissionId, payload) =>
  fetchFromApi(
    `${basePath}/${submissionId}/upload`,
    optionsForFileRequest(payload)
  );

const followSubmission = submissionId =>
  fetchFromApi(
    `${basePath}/${submissionId}/follow`,
    optionsForPatchRequest()
  );

const unfollowSubmission = submissionId =>
  fetchFromApi(
    `${basePath}/${submissionId}/unfollow`,
    optionsForPatchRequest()
  );

const addFollowers = (submissionId, followerIds) =>
    fetchFromApi(
        `${basePath}/${submissionId}/followers`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(followerIds),
        }
    );

const getExternalFollowers = submissionId =>
    fetchFromApi(`${basePath}/${submissionId}/externalfollowers`);

export default {
  getSubmission,
  getSubmissions,
  getSubmissionsCalendar,
  uploadSubmissionFile,
  followSubmission,
  unfollowSubmission,
  addFollowers,
  getExternalFollowers
};
